import { Config } from '../services/config/config.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FantasyStatsExternalClient {
  public endpoint: string;

  constructor(public http: HttpClient, public _config: Config) {
    this.endpoint = _config.CONFIG.fantasyStatsUrl + '/PoolSeasonStats/';
  }

  get(poolId: string | number): Observable<any> {

    return this.http.get(this.endpoint + poolId)
      .pipe(
        map(data => data),
        catchError(err => throwError(err))
      );
  }
}
